<template>
  <div class="detail-view">
    <loading-screen v-if="loading" />
    <div v-if="!loading" class="container">
      <div class="content flex">
        <div class="w-full md:w-1/2 m-auto">
          <b-content-card :item="item" :config="config" type="detail" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BContentCard from "@/components/BContentCard";
import LoadingScreen from "@/components/LoadingScreen";
import FieldTypes from "@/constants/field-types";

export default {
  name: "DetailView",

  components: {
    BContentCard,
    LoadingScreen
  },

  data() {
    return {
      loading: true,
      fieldTypes: FieldTypes,
      itemIndex: -1
    };
  },

  computed: {
    config() {
      return this.$store.state.config.detailView;
    },
    caption() {
      return {
        type: this.config?.caption?.type,
        value: this.item[this.config?.caption?.name]
      };
    },
    description() {
      return {
        type: this.config?.description?.type,
        value: this.item[this.config?.description?.name]
      };
    },
    title() {
      return {
        type: this.config?.title?.type,
        value: this.item[this.config?.title?.name]
      };
    },
    image() {
      return {
        type: this.config?.image?.type,
        value: this.item[this.config?.image?.name]
      };
    },
    items() {
      return this.$store.state.items;
    },
    item() {
      if (this.itemIndex >= 0) {
        return this.items[this.itemIndex];
      }
      return {};
    }
  },

  watch: {
    config(newVal) {
      if (newVal) {
        this.getItems();
      }
    }
  },

  beforeMount() {
    if (!this.items.length && this.config) {
      this.getItems();
    } else if (!this.config) {
      this.loading = true;
    } else {
      this.loading = false;
      this.itemIndex = this.items.findIndex(
        item => item.slug == this.$route.params.slug
      );
    }
  },

  methods: {
    async getItems() {
      this.loading = true;
      await this.$store.dispatch("getItems");

      this.itemIndex = this.items.findIndex(
        item => item.slug == this.$route.params.slug
      );

      if (this.itemIndex === -1) {
        this.$router.push({ name: "404" });
      }

      this.loading = false;
    },

    visitLink(link) {
      window.open(link);
    }
  }
};
</script>
